<template>
  <div>
    <page-header :actions="headerActionConfig" :page="pageOptions" />
    <div class="row bg-secondary-1 p-3 rounded">
      <div class="col-md-3 d-flex">
        <custom-drop-down
          id="ddlAcademicYear"
          v-model="filter.academicYearId"
          class="flex-grow-1"
          :clearable="false"
          fieldkey="id"
          fieldname="name"
          :options="catalog.academicYears"
          placeholder="Seleccione Año Fiscal"
        />
      </div>
      <div class="col-md-3 d-flex">
        <custom-drop-down
          id="ddlHiringTypes"
          v-model="filter.hiringType"
          class="flex-grow-1"
          fieldkey="id"
          fieldname="name"
          :options="hiringTypes"
          placeholder="Seleccione Tipo de Contratación"
        />
      </div>
      <div class="col-md-3 d-flex">
        <custom-drop-down
          id="ddlFigureTypes"
          v-model="filter.figureType"
          class="flex-grow-1"
          fieldkey="id"
          fieldname="name"
          :options="catalog.figureTypes"
          placeholder="Seleccione Tipo de Cifra"
        />
      </div>
      <div class="col-md-3 d-flex">
        <action-button
          i="fas fa-search"
          text="Buscar"
          variant="success"
          @click="onSearchHandler"
        />
      </div>
    </div>
    <custom-separator class="pt-3 mb-4" text="Resultado de Cifras en Sistema" />
    <div class="row">
      <div class="col">
        <div
          v-for="(item, index) in accountNumbers.data"
          :key="'account-number' + index"
        >
          <custom-callout class="mb-3 custom-callout">
            <div class="row">
              <div class="col-md-4">
                <div class="color-secondary-6 font-14">Número de Cifra:</div>
                <div class="font-weight-bold color-black font-16">
                  {{ item.fullNumber }}
                </div>
              </div>
              <div class="col-md-6">
                <div class="row">
                  <!--Grupo de Edad-->
                  <div class="col">
                    <div class="color-secondary-6 font-14">Grupo de Edad:</div>
                    <div class="font-weight-normal color-black font-16">
                      {{ item.serviceName }}
                    </div>
                  </div>

                  <div class="col">
                    <div class="color-secondary-6 font-14">
                      Tipo de Contratación:
                    </div>
                    <div class="font-weight-normal color-black font-16">
                      {{ item.hiringTypeName }}
                    </div>
                  </div>

                  <div class="col">
                    <div class="color-secondary-6 font-14">Tipo de Cifra:</div>
                    <div class="font-weight-normal color-black font-16">
                      {{ item.figureTypeDescription }}
                    </div>
                  </div>

                  <div class="col">
                    <div class="color-secondary-6 font-14">Vigencia:</div>
                    <div class="font-weight-bold color-black font-16">
                      {{ item.effectiveDate }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-2 text-right">
                <action-button
                  class="ml-4 px-4 transparent-color"
                  i="fas fa-file-search"
                  text="Ver Detalles"
                  variant="outline-success"
                  @click="onEditHandler(item)"
                />
              </div>
            </div>
            <!--Second Row-->
            <div class="d-flex mt-2">
              <!--                  Centro de Servicio-->
              <div v-if="item.caats.length > 0 && isEquipoAsistivo(item)">
                <div class="color-secondary-6 font-14">
                  Centro de Servicio:
                </div>
                <div
                  v-for="(caat, index2) in item.caats"
                  :key="`caat-row-${index2}`"
                  class="font-weight-bold color-black font-16"
                >
                  {{ caat.name }}
                </div>
              </div>
            </div>
          </custom-callout>
        </div>
        <pagination
          v-if="showPagination"
          :data="accountNumbers.pagination"
          :show-text="true"
          @pagination-go-page="goToPage"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { PageHeader } from '@/shared/components/PageHeader/index';
import CustomSeparator from '@/components/common/CustomSeparator';
import CustomCallout from '@/components/common/CustomCallout';
import { CustomDropDown, ActionButton } from '@/components/common';
import Pagination from '@/components/common/Pagination.vue';
import {
  getAcademicYears as _getAcademicYears,
  searchPurchaseOrders as _searchPurchaseOrders,
} from '@/modules/shared/provideraccountnumber.api.js';
import { getFigureType as _getFigureType } from '@/modules/shared/figureType.api.js';
import storeMixin from '@/shared/mixins/storeGenerator';

import { getHiringTypes as _getHiringTypes } from '@/modules/shared/code.api.js';

const ADD_ACCOUNT_NUMBER_ROUTE_NAME = 'AccountNumberAdd';
const EDIT_ACCOUNT_NUMBER_ROUTE_NAME = 'AccountNumberEdit';
const MODULE_NAME = 'AccountNumberModule';

export default {
  name: 'AccountNumberHistory',
  components: {
    PageHeader,
    CustomSeparator,
    CustomCallout,
    CustomDropDown,
    ActionButton,
    Pagination,
  },
  mixins: [storeMixin],
  data: () => ({
    moduleName: MODULE_NAME,
    filter: {
      academicYearId: null,
      hiringType: null,
      figureType: null,
    },
    catalog: {
      academicYears: [],
      figureTypes: [],
    },
    accountNumbers: {
      data: [],
      pagination: {
        perPage: 15,
        currentPage: 1,
        totalItemCount: 0,
        pageCount: 0,
        count: 0,
      },
    },
    hiringTypes: [],
  }),
  computed: {
    showPagination() {
      return (
        this.accountNumbers.data.length > 0 &&
        this.accountNumbers.pagination.totalItemCount >
          this.accountNumbers.pagination.perPage
      );
    },
    pageOptions() {
      return {
        title: 'Cifras de Cuentas',
        icon: 'fas fa-user-tie',
        routes: ['Proveedor', 'Cifras de Cuentas'],
      };
    },
    headerActionConfig() {
      return [
        {
          text: 'Añadir',
          icon: 'fas fa-file-plus',
          variant: 'success',
          click: this.addAccountNumber,
          visible: true,
        },
      ];
    },
    Payload() {
      const filterModel = this.filter;
      return {
        academicYearId: filterModel.academicYearId?.id,
        hiringType: filterModel.hiringType?.id ?? null,
        figureType: filterModel.figureType?.id ?? null,
        pageIndex: 1,
        pageSize: 15,
      };
    },
  },
  async mounted() {
    await Promise.all([
      this.callGetAcademicYears(),
      this.callGetFigureType(),
      this.getHiringTypes(),
    ]);
  },
  destroyed() {
    this.persistData();
  },
  methods: {
    async callGetAcademicYears() {
      const { data } = await _getAcademicYears();
      if (data) {
        this.catalog.academicYears = data;
        this.filter.academicYearId = data.find((x) => x.selected);
      }
    },
    async callGetFigureType() {
      const { data } = await _getFigureType();
      if (data) {
        this.catalog.figureTypes = data;
      }
    },
    async callSearchPurchaseOrders(pageIndex) {
      this.Payload.pageIndex = pageIndex;
      if (this.Payload.academicYearId) {
        const { data: result } = await _searchPurchaseOrders(this.Payload);
        if (result) {
          this.accountNumbers = {
            data: result.data,
            pagination: {
              ...this.accountNumbers.pagination,
              currentPage: result.currentPage,
              totalItemCount: result.totalItemCount,
              pageCount: result.pageCount,
              count: result.count,
            },
          };
        }
      }
    },
    addAccountNumber() {
      this.$router.push({
        name: ADD_ACCOUNT_NUMBER_ROUTE_NAME,
      });
    },
    onSearchHandler() {
      this.callSearchPurchaseOrders(0);
    },
    onEditHandler(item) {
      this.$router.push({
        name: EDIT_ACCOUNT_NUMBER_ROUTE_NAME,
        params: {
          id: item.id,
          account: item.account,
          dept: item.dept,
          fund: item.fund,
          program: item.program,
          class: item.class,
          budRef: item.budRef,
          pcBusUnit: item.pcBusUnit,
          project: item.project,
          activity: item.activity,
          serviceId: {
            id: item.serviceId,
            name: item.serviceName,
          },
          isActive: item.isActive,
          dateFrom: new Date(item.from),
          dateTo: new Date(item.to),
          hiringTypeCd: item.hiringTypeCd,
          figureTypeId: item.figureTypeId ?? null,
          caats: item.caats,
        },
      });
    },
    goToPage(page) {
      if (page) {
        this.callSearchPurchaseOrders(page);
      }
    },
    isEquipoAsistivo(item) {
      return item.hiringTypeCd === this.hiringTypes[0]?.id;
    },
    async getHiringTypes() {
      const { data } = await _getHiringTypes();
      if (data) {
        this.hiringTypes = data;
      }
    },
  },
};
</script>
